// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"08dc887f","304":"f1708f41","854":"57a76e12","992":"8dcef556"}[chunkId] + ".chunk.js";
};